import { Fragment } from "react"

import { humanizeKey } from "@/admin/monitoring/run-presentation"
import { usd } from "@/terminal/monitoring/usage-presentation"

// File values are frozen by compilation. Render their recorded fields without
// looking up today's identity names or translating them into legacy contracts.
export const StoredValue = ({ value }: { value: unknown }) => {
  if (value === null || value === undefined)
    return <span className="text-muted-foreground">Not recorded</span>
  if (typeof value !== "object")
    return <span className="break-words">{String(value)}</span>
  if (Array.isArray(value))
    return value.length === 0 ? (
      <span className="text-muted-foreground">None</span>
    ) : (
      <ul className="space-y-2">
        {value.map((item, index) => (
          <li key={index} className="border-l pl-3">
            <StoredValue value={item} />
          </li>
        ))}
      </ul>
    )
  return (
    <dl className="space-y-1">
      {Object.entries(value).map(([key, field]) => (
        <Fragment key={key}>
          <dt className="text-muted-foreground text-xs">{humanizeKey(key)}</dt>
          <dd className="pl-2">
            <StoredValue
              value={
                typeof field === "number" && /(Usd|_usd)$/.test(key)
                  ? usd(field)
                  : field
              }
            />
          </dd>
        </Fragment>
      ))}
    </dl>
  )
}

// The raw stored record behind a presented value, collapsed by default.
export const StoredDetails = ({
  summary,
  value,
}: {
  summary: string
  value: unknown
}) => (
  <details className="text-xs">
    <summary className="text-muted-foreground">{summary}</summary>
    <div className="mt-2">
      <StoredValue value={value} />
    </div>
  </details>
)
